"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var before_1 = require("./before");
var replaceWith_1 = require("./replaceWith");
exports.swap = function (first, second, placeholder_generator) {
    if (placeholder_generator === void 0) { placeholder_generator = function () {
        return document.createElement("span");
    }; }
    var first_placeholder = placeholder_generator();
    var second_placeholder = placeholder_generator();
    before_1.before(first, first_placeholder);
    before_1.before(second, second_placeholder);
    replaceWith_1.replaceWith(second_placeholder, first);
    replaceWith_1.replaceWith(first_placeholder, second);
};
